module.exports = "/images/london-19.jpg";